<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from 'vue-router';

import VButton from '@components/buttons/VButton/VButton.vue';
import VLoader from '@components/loader/VLoader.vue';
import useUnsubscribeDoUnsubscribeMutation from '@modules/unsubscribe/mutations/useUnsubscribeDoUnsubscribeMutation';
import useUnsubscribeCheckStatusQuery from '@modules/unsubscribe/queries/useUnsubscribeCheckStatusQuery';
import { watchImmediate } from '@vueuse/core';

import { TRANSLATION_GROUP_UNSUBSCRIBE } from '../../constants';

const route = useRoute();

const token = ref<string>(route.params?.token.toString());
const showSuccess = ref(false);
const { data, isLoading } = useUnsubscribeCheckStatusQuery(token);
const { mutateAsync, isLoading: isLoadingSubmission } = useUnsubscribeDoUnsubscribeMutation();

watchImmediate(data, (newValue) => {
  showSuccess.value = !!newValue?.unsubscribe_status;
});

async function doUnsubscribe(): Promise<void> {
  await mutateAsync(token.value);
  showSuccess.value = true;
}
</script>

<template>
  <VLoader v-data-qa-auto-id="'UnsubscribePage'" :loading="isLoading">
    <div class="min-h-[100px] pt-6 text-center text-muted-color">
      <template v-if="!showSuccess">
        <div>
          <div class="mb-6">
            {{ $getTranslation(TRANSLATION_GROUP_UNSUBSCRIBE, 'WANT_TO_UNSUBSCRIBE') }}
          </div>
          <VButton
            :label="$getTranslation(TRANSLATION_GROUP_UNSUBSCRIBE, 'UNSUBSCRIBE_BUTTON')"
            :loading="isLoadingSubmission"
            @click="doUnsubscribe"
          />
        </div>
      </template>
      <template v-else>
        <span>{{ $getTranslation(TRANSLATION_GROUP_UNSUBSCRIBE, 'HAVE_BEEN_UNSUBSCRIBED') }}</span>
      </template>
    </div>
  </VLoader>
</template>
